import { RootState } from '../../../../../init-store';

export const selectBackButtonVisible = (state: RootState) => {
    return state.call.messenger.backButtonVisible;
};
